import React, { Fragment } from 'react';
import { TooltipWrap, TooltipBody } from './Tooltip.styled';

import InfoIcon from './InfoIcon';
import WarnIcon from './WarnIcon';
import ErrorIcon from './ErrorIcon';
import { Stack, Cover, Cluster, Box, Paragraph } from '@thecb/components';

const TooltipIcons = {
  info: InfoIcon,
  warn: WarnIcon,
  error: ErrorIcon,
};

const Tooltip = ({
  text,
  bottom,
  right,
  left,
  height,
  width,
  variant = 'info',
  noIcon,
  children,
}) => {
  const Icon = TooltipIcons[variant];
  return (
    <TooltipWrap>
      {noIcon ? <Fragment>{children} </Fragment> : <Icon />}
      <TooltipBody
        bottom={bottom}
        right={right}
        left={left}
        height={height}
        width={width}
        variant={variant}
      >
        <Stack direction="row" childGap="8px" fullHeight>
          <Cover minHeight="100%" singleChild>
            <Box padding="0">
              <Icon />
            </Box>
          </Cover>
          <Box padding="0" extraStyles="display: flex; align-items: center;">
            <Cluster justify="flex-start" align="center">
              <Box padding="0">
                <Paragraph variant="pXS" extraStyles={`text-align: left;`}>
                  {text}
                </Paragraph>
              </Box>
            </Cluster>
          </Box>
        </Stack>
      </TooltipBody>
    </TooltipWrap>
  );
};

export default Tooltip;
